// slick slider script
document.addEventListener('DOMContentLoaded', function () {
    // Initialize main slider
    $('.product-images-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.product-thumbnails-slider',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: false
                }
            }
        ]
    });

    // Initialize thumbnail slider
    $('.product-thumbnails-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product-images-slider',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    arrows: false
                }
            }
        ]
    });

    // Pause video when sliding
    $('.product-images-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var currentSlideElement = $(slick.$slides[currentSlide]);
        var video = currentSlideElement.find('video');
        if (video.length) {
            video[0].pause();
        }
    });
});

// popup script
document.addEventListener('DOMContentLoaded', function () {
    const questionMarks = document.querySelectorAll('.question-mark-icon');
    const popupOverlay = document.querySelector('.popup-overlay');
    const popupClose = document.querySelector('.popup-close');
    const popupWrapper = document.querySelector('.popup-wrapper');

    // Open popup
    questionMarks.forEach(icon => {
        icon.addEventListener('click', function (e) {
            e.stopPropagation();
            popupOverlay.classList.add('active');
            popupWrapper.classList.add('active');
            document.body.style.overflow = 'hidden'; // Prevent background scrolling
        });
    });

    // Close popup functions
    function closePopup() {
        popupOverlay.classList.remove('active');
        popupWrapper.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
    }

    // Close with close button
    popupClose.addEventListener('click', function (e) {
        e.stopPropagation();
        closePopup();
    });

    // Close when clicking overlay
    popupOverlay.addEventListener('click', function (e) {
        if (e.target === popupOverlay) {
            closePopup();
        }
    });

    // Close with ESC key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popupOverlay.classList.contains('active')) {
            closePopup();
        }
    });
});

// add to cart script
document.addEventListener('DOMContentLoaded', function () {
    const addToCartButton = document.getElementById('AddToCart');
    const variantSelect = document.getElementById('ProductSelect');

    addToCartButton.addEventListener('click', function () {
        const selectedVariantId = variantSelect.value;

        if (!selectedVariantId) {
            console.error('No variant selected');
            return;
        }

        const SKIO = document.querySelector('skio-plan-picker');
        let sellingPlanId = '';

        if (SKIO) {
            sellingPlanId = SKIO.selectedSellingPlan ? SKIO.selectedSellingPlan.id : '';
        }

        // Disable button during request
        addToCartButton.disabled = true;
        addToCartButton.textContent = 'Adding...';

        // Add to cart using Shopify AJAX API
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: selectedVariantId,
                    quantity: 1,
                    selling_plan: sellingPlanId
                }]
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 422) {
                    throw new Error('Product is out of stock');
                }

                // Success - Update cart count and show success message
                updateCartCount();
                addToCartButton.textContent = 'Added to Cart!';

                // Reset button after 2 seconds
                setTimeout(() => {
                    addToCartButton.disabled = false;
                    addToCartButton.textContent = 'Add to Cart';
                }, 2000);
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
                addToCartButton.textContent = 'Error - Try Again';
                addToCartButton.disabled = false;
            });
    });

    // Function to update cart count
    function updateCartCount() {
        fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(cart => {
                // Assuming you have a cart count element with class 'cart-counter'
                const cartCountElements = document.querySelectorAll('.cart-counter');
                cartCountElements.forEach(element => {
                    element.textContent = cart.item_count;
                });
                openCartDrawerPopup();
            })
            .catch(error => console.error('Error fetching cart:', error));
    }
});

// accordions script
document.addEventListener('DOMContentLoaded', function() {
    const accordionHeaders = document.querySelectorAll('.accordion-header');
    
    accordionHeaders.forEach(header => {
        header.addEventListener('click', function () {
            const accordionItem = this.parentElement;
            const isActive = accordionItem.classList.contains('active');

            // Close all accordions
            document.querySelectorAll('.accordion-item').forEach(item => {
                item.classList.remove('active');
                const content = item.querySelector('.accordion-content');
                content.style.maxHeight = null;
                // content.style.paddingBottom = "0px";
            });

            // If the clicked accordion wasn't active, open it
            if (!isActive) {
                accordionItem.classList.add('active');
                const content = accordionItem.querySelector('.accordion-content');
                content.style.maxHeight = content.scrollHeight + "px";
                // content.style.paddingBottom = "20px";
            }
        });
    });
});

// accordions content script
document.addEventListener('DOMContentLoaded', function() {
    const accordionContents = document.querySelectorAll('.accordion-content[data-rich-text]');
    
    accordionContents.forEach(content => {
        try {
            const richTextData = JSON.parse(content.dataset.richText);
            if (richTextData.children && richTextData.children[0].children) {
                const ul = document.createElement('ul');
                
                richTextData.children[0].children.forEach(item => {
                    if (item.children && item.children[0].value) {
                        const li = document.createElement('li');
                        li.textContent = item.children[0].value;
                        ul.appendChild(li);
                    }
                });
                
                content.innerHTML = ''; // Clear the JSON string
                content.appendChild(ul);
            }
        } catch (e) {
            console.error('Error parsing rich text:', e);
            // Fallback: display raw content if parsing fails
            content.textContent = content.dataset.richText;
        }
    });
});

class VideoModal {
    constructor() {
        this.modal = document.getElementById('videoModal');
        this.triggers = document.querySelectorAll('.js-video-modal-trigger');
        this.closeBtn = this.modal.querySelector('.video-modal__close');
        this.overlay = this.modal.querySelector('.video-modal__overlay');
        this.iframe = document.getElementById('videoIframe');
        
        this.init();
    }

    init() {
        // Add click events to all trigger buttons
        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                const videoUrl = trigger.href;
                const videoId = this.getYoutubeId(videoUrl);
                if (videoId) {
                    this.openModal(videoId);
                }
            });
        });

        // Close button event
        this.closeBtn.addEventListener('click', () => this.closeModal());
        
        // Overlay click event
        this.overlay.addEventListener('click', () => this.closeModal());
        
        // Escape key event
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
                this.closeModal();
            }
        });
    }

    getYoutubeId(url) {
        console.log('Processing URL:', url); // Debug log
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        console.log('Match result:', match); // Debug log
        return (match && match[2].length === 11) ? match[2] : null;
    }

    openModal(videoId) {
        console.log('Opening modal with video ID:', videoId); // Debug log
        this.iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        this.modal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
    }

    closeModal() {
        this.modal.classList.remove('is-active');
        this.iframe.src = '';
        document.body.style.overflow = '';
    }
}

// Initialize the video modal
document.addEventListener('DOMContentLoaded', () => {
    console.log('Initializing video modal'); // Debug log
    new VideoModal();
});